import { render, staticRenderFns } from "./IconSvgNews.vue?vue&type=template&id=4abd1241&scoped=true&"
import script from "./IconSvgNews.vue?vue&type=script&lang=js&"
export * from "./IconSvgNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd1241",
  null
  
)

export default component.exports